<div class="col-lg-12 px-0 spreadsheet-filters">
  @if (filtersNb > 0) {
    <span class="filters-nb">
      {{ 'pages.decision.spreadsheet.header.filters_nb' | translate: {filtersNb: filtersNb} }}
    </span>
  }
  @if (filtersNb > 0) {
    <span class="filters-button delete" (click)="deleteFilters()">
      {{ 'pages.decision.spreadsheet.header.delete_filters' | translate }}
    </span>
  }
  @if (filtersNb === 0) {
    <span class="filters-button" (click)="toggleFilters()">
      {{ (columnsDisplayed ? 'pages.decision.spreadsheet.header.hide_filters'
      : 'pages.decision.spreadsheet.header.add_filters') | translate
      }}
    </span>
  }
</div>
